import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import LastMinuteSummary from './LastMinuteSummary'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LastMinutePropertyDetails from './LastMinutePropertyDetails'
import OfferPageLabelGroup from '../OfferPageLabelGroup'

const OfferIntroGrid = styled(LayoutContainer)`
  display: grid;
  padding: ${rem(20)};
  grid-template-columns: 1fr;
  grid-gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr 1fr;
    padding: ${rem(20)} ${rem(40)};
  }

  ${mediaQueryUp.desktop} {
    padding: ${rem(30)} ${rem(12)};
    grid-gap: ${rem(16)} ${rem(40)};
    grid-template-columns: 1fr min-content;
    grid-template-rows: min-content min-content min-content min-content 1fr;
  }
`

const OfferBadgeIntroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-row: 4;

  ${mediaQueryUp.tablet} {
    grid-row: 3;
    grid-column: 1;
  }
`

const OfferBadgeTagSection = styled(BodyText)`

  > * {
    margin: 0;
  }
`

const SummaryBlock = styled.div`
  display: none;

  ${mediaQueryUp.tablet} {
    position: sticky;
    /* height of the filter bar */
    top: ${rem(64)};
    display: block;
    align-self: flex-start;
    grid-row: 3;
    grid-column: 2;
  }

  ${mediaQueryUp.desktop} {
    grid-row: 2 / span 3;
    grid-column: 2;
  }

  > * + * {
    margin-top: ${rem(12)};
  }
`

const HotelSummary = styled(LastMinuteSummary)`
  display: block;
  align-self: flex-start;
  min-width: ${rem(290)};

  ${mediaQueryUp.desktop} {
    min-width: ${rem(370)};
  }
`

interface Props {
  offer: App.HotelOffer;
  className?: string;
}

function LastMinuteIntro(props: Props) {
  const {
    offer,
    className,
  } = props

  const property = offer.property
  const location = [offer.locationHeading, offer.locationSubheading].filter(t => t).join(', ')

  return (
    <OfferIntroGrid className={className} data-testid="offer-intro">
      <OfferPageLabelGroup offer={offer} />
      <OfferBadgeIntroWrapper>
        {offer.badge && <OfferBadgeTagSection variant="medium">
          <OfferBadgeLabel badge={offer.badge} />
        </OfferBadgeTagSection>}
        <LastMinutePropertyDetails
          offer={offer}
          property={property}
          location={location}
        />
      </OfferBadgeIntroWrapper>
      <SummaryBlock>
        <HotelSummary />
      </SummaryBlock>
    </OfferIntroGrid>
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
}), LastMinuteIntro)
